import { render, staticRenderFns } from "./marketAttribute.vue?vue&type=template&id=71e9e5b3&scoped=true"
import script from "./marketAttribute.vue?vue&type=script&lang=js"
export * from "./marketAttribute.vue?vue&type=script&lang=js"
import style0 from "./marketAttribute.vue?vue&type=style&index=0&id=71e9e5b3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e9e5b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e9e5b3')) {
      api.createRecord('71e9e5b3', component.options)
    } else {
      api.reload('71e9e5b3', component.options)
    }
    module.hot.accept("./marketAttribute.vue?vue&type=template&id=71e9e5b3&scoped=true", function () {
      api.rerender('71e9e5b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/marketAttribute.vue"
export default component.exports